import type { ListingUnit } from "./emailService";
import { fetchWithAuth } from "../lib/api";

// ── Freshness check (lightweight, no Lambda) ──────────────────────

export interface PropertyFreshnessItem {
  property_id: string;
  last_scraped: string | null;
  is_stale: boolean;
  freshness_tier: "fresh" | "aging" | "stale";
  serve_pricing: boolean;
  badge: "green" | "yellow" | "red";
  serve_note: string | null;
  estimated_refresh_seconds: number | null;
}

export interface FreshnessCheckResult {
  properties: PropertyFreshnessItem[];
  has_stale: boolean;
}

export async function checkPropertyFreshness(
  propertyIds: string[]
): Promise<FreshnessCheckResult> {
  if (propertyIds.length === 0) {
    return { properties: [], has_stale: false };
  }
  try {
    const result = await fetchWithAuth<FreshnessCheckResult>(
      "/scrape-guard/freshness-check",
      {
        method: "POST",
        body: JSON.stringify({
          property_ids: propertyIds,
        }),
      }
    );
    console.log("[freshness-check] result:", result);
    return result;
  } catch (err) {
    console.error("[freshness-check] failed:", err);
    return {
      properties: propertyIds.map((id) => ({
        property_id: id,
        last_scraped: null,
        is_stale: true,
        freshness_tier: "stale" as const,
        serve_pricing: false,
        badge: "red" as const,
        serve_note: "verify with property",
        estimated_refresh_seconds: null,
      })),
      has_stale: true,
    };
  }
}
